jQuery(document).ready(function($) {

  // set comments textarea placeholder and add span to create button effect 
  // for tribute candle section
  $('<span>Light a candle</span>').insertAfter('.acf-true-false label input');
  $('.comments-block form textarea').attr('placeholder', 'Write a tribute');

  
  // Show "our-packages" btn when on mobile 
  $('.view-package-btn a').on('click', function() {
    var blockList = $(this).parent().parent().parent().find('ul'),
        blockBtn = $(this).parent().parent().find('.arrange-btn');

    $(this).fadeOut(200, function() {
      $(blockList).fadeIn();
      $(blockBtn).fadeIn();  
    });
  });


  // When on "arrange a crematin" page, the functionality is different on mobile.
  // Listen for load event and re-arrange the package blocks to we don't have 
  // to duplicate html/css
  // $(window).on('load', function() {
  //   if ($(window).width() >= 768) {
  //     $('.arrange-packages .wp-block-column').on('mouseenter', function() {
  //       $(this).addClass('highlight grow');
  //       $(this).find('.wp-block-buttons').addClass('show-btn');
  //     });
    
  //     $('.arrange-packages .wp-block-column').on('mouseleave', function() {
  //       $(this).removeClass('highlight grow');
  //       $(this).find('.wp-block-buttons').removeClass('show-btn');
  //     });  
  //   }
  // });
 

  // Our process list animation - when user scrolls to #our-process
  // fadeIn the list items and transition the list height
  $(window).on('scroll', function() {
    var elm = $('#our-process');
    var windowScrollCount = $(this).scrollTop();
    
    function elementScrolled(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();
      var elemTop = $(elem).offset().top + 125;
      return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
    };

    if (elm.length) {
      if (elementScrolled('#our-process')) {
        var blocks = document.querySelectorAll('.our-process ul li');
        var animationFrame = Math.round(windowScrollCount / 100);

        if (animationFrame >= 17) { // 26
          blocks[0].classList.add('fade-in');
        } else {
          // blocks[0].classList.remove('fade-in');
        }
        
        if (animationFrame >= 19) { // 28
          blocks[1].classList.add('fade-in');
        } else {
          // blocks[1].classList.remove('fade-in');
        }

        if (animationFrame >= 20) { // 29
          blocks[2].classList.add('fade-in');
        } else {
          // blocks[2].classList.remove('fade-in');
        }

        if (animationFrame >= 22) { // 31
          blocks[3].classList.add('fade-in');
        } else {
          // blocks[3].classList.remove('fade-in');
        }

        if (animationFrame >= 23) { // 32
          blocks[4].classList.add('fade-in');
        } else {
          // blocks[4].classList.remove('fade-in');
        }

        if ($(window).width() >= 768) {
          $('.our-process figure').addClass('swing-tree');
        };
      }
    };
  });


  // auto scroll funcitonality for navigation items in the header
  function filterPath(string) {
    return string
      .replace(/^\//, '')
      .replace(/(index|default).[a-zA-Z]{3,4}$/, '')
      .replace(/\/$/, '');
  }
  
  
  var locationPath = filterPath(location.pathname);
  $('a[href*="#"]').each(function () {
    var thisPath = filterPath(this.pathname) || locationPath;
    var hash = this.hash;
    if ($("#" + hash.replace(/#/, '')).length) {
      if (locationPath == thisPath && (location.hostname == this.hostname || !this.hostname) && this.hash.replace(/#/, '')) {
        var $target = $(hash), target = this.hash;
        if (target) {
          $(this).click(function (event) {
            event.preventDefault();
            $('html, body').animate({scrollTop: $target.offset().top}, 1000, function () {
              location.hash = target; 
              $target.focus();
              if ($target.is(":focus")){ //checking if the target was focused
                return false;
              }else{
                $target.attr('tabindex','-1'); //Adding tabindex for elements not focusable
                $target.focus(); //Setting focus
              };
            });       
          });
        }
      }
    }
  });

});